export default __webpack_public_path__ + "static/media/icon-truck.a708526e.png";